import BaseSobrevivenciaRequest from "../BaseSobrevivenciaRequest"; 

export default class EtapaRequest extends BaseSobrevivenciaRequest {
  constructor( 
    public canal: string = "PortalBE",
    public codUsuario: string = "",
    public numPreSolicitud: number= 0,
    public codEtapa : number=0
  ) {
    super(canal, codUsuario, numPreSolicitud);
  }
}
